import { Radio, RadioChangeEvent, Tooltip } from 'antd';
import { CustomRuleCodeEnum } from 'domains/skuDomain';

interface PriceInputProps {
  value?: string;
  onChange?: ((e: RadioChangeEvent) => void) | undefined;
  disabled?: boolean;
}

export const FormCustomRuleCode = ({
  value,
  onChange,
  disabled,
}: PriceInputProps) => {
  const plainOptions = [
    {
      label: CustomRuleCodeEnum.NONE,
      value: CustomRuleCodeEnum.NONE,
      title:
        'Formula: flat_size_width = finished_size w and  flat_size_length = finished_size L',
    },
    {
      label: CustomRuleCodeEnum.CFEBDP,
      value: CustomRuleCodeEnum.CFEBDP,
      title:
        'Formula: flat_size_width = (finished_size w) * (fold_panel_count/2) &  flat_size_length = (finished_size L) * (fold_panel_count/2)',
    },
    {
      label: CustomRuleCodeEnum.CFUBDP,
      value: CustomRuleCodeEnum.CFUBDP,
      title:
        'Formula: flat_size_width = (finished_size w) * (fold_panel_count/2) and  flat_size_length = (finished_size L) * (fold_panel_count/3)',
    },
    {
      label: CustomRuleCodeEnum.CFUP,
      value: CustomRuleCodeEnum.CFUP,
      title:
        'Formula: flat_size_width = (finished_size w) * (fold_panel_count-1) and flat_size_length = (finished_size_length)',
    },
    {
      label: CustomRuleCodeEnum.SFEP,
      value: CustomRuleCodeEnum.SFEP,
      title:
        'Formula: flat_size_width = (finished_size w * fold_panel_count) and flat_size_length = (finished_size_length)',
    },
    // {
    //   label: CustomRuleCodeEnum.R4PG,
    //   value: CustomRuleCodeEnum.R4PG,
    //   title:
    //     'Formula: flat_size_width = finished_size w and  flat_size_length = finished_size L',
    // },
  ];

  return (
    <Radio.Group value={value} onChange={onChange} disabled={disabled}>
      {plainOptions.map((item) => (
        <Radio value={item.value} key={item.value}>
          <Tooltip title={item.title}>
            <span>{item.label}</span>
          </Tooltip>
        </Radio>
      ))}
    </Radio.Group>
  );
};
